import { createSelector } from '@ngrx/store';
import { getNotificationsRootState, NotificationsState } from 'app/notifications/store';

import * as fromMessages from '../reducers/message-reducers';
import { MessageType } from './../../message';

const filterSystemAlerts = (state: fromMessages.State) =>
  state.filter(message => message.type === MessageType.SystemAlert);
const filterAlerts = (state: fromMessages.State) => state.filter(message => message.type === MessageType.Alert);
const filterToasts = (state: fromMessages.State) => state.filter(message => message.type === MessageType.Toast);

const getMessagesState = createSelector(getNotificationsRootState, (state: NotificationsState) => state.messages);

export const getSystemAlerts = createSelector(getMessagesState, filterSystemAlerts);

export const getAlerts = createSelector(getMessagesState, filterAlerts);

export const getToasts = createSelector(getMessagesState, filterToasts);
